import { Component, OnInit } from "@angular/core";
import { User } from "../../core/interfaces/user";
import { FormBuilder, FormGroup, Validators ,NgForm} from "@angular/forms";
import { LoginService } from "./login.service";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs/Observable";
import { NgxSpinnerService } from "ngx-spinner";
import { NavigationService } from 'src/app/core/services/navigation/navigation.service';
import { toastmessagesService } from "../../core/services/messages/toastmessages.service";
import { DefaultState } from 'src/store/actions/authenticationActions';
import { Subscription } from 'rxjs/Subscription';
import { AppState, selectAuthState } from 'src/store/reducers';
import { NextstepsService } from '../../pages/nextsteps/nextsteps.service';
import { TranslateService } from "@ngx-translate/core";
import { CommonService } from '../../../app/core/services/common/common.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"]
})
export class LoginComponent implements OnInit, User {
  public email;
  loginForm: FormGroup;
  defaultState;
  getState: Observable<any>;
  errorMessage: string | null;
  loginSubscription: Subscription;
queryPram;
  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private loginService: LoginService,
    private store: Store<any>,
    private spinner: NgxSpinnerService,
    private message: toastmessagesService,
    private navigate: NavigationService,
    private nextStep: NextstepsService,
    private translate: TranslateService,
    private commonService: CommonService


  ) {
    this.loginForm = fb.group(LoginService.formFields());
    // this.getState = this.store.select("loginReducer");
    // this.defaultState =   this.store.select("defaultReducer");


    this.getState = this.store.select(selectAuthState);
  }

  ngOnInit() {
    if(localStorage.getItem('token')){
      this.navigate.navigateTo('dashboard')
    }
    this.getQueryPramas();
    this.loginSubscription = this.getState.subscribe(state => {
      // this.errorMessage = state.errorMessage;

      if (state.action === 'login') {
        this.errorMessage = state.errorMessage;
        this.showMessage(state);
        this.spinner.hide();

        // this.store.dispatch(new DefaultState({}));
      }
    })
  }
  getQueryPramas(){
   let params = this.route.snapshot.queryParams;
    if(params.id){
      this.queryPram = params.id
    }
  }
  ngOnDestroy() {
    this.loginSubscription.unsubscribe();
  }



  login() {
  
    if (this.loginForm.dirty && this.loginForm.valid) {
      this.spinner.show();
      const userObject: User = {
        email: this.retrieveData("email"),
        password: this.retrieveData("password"),
        account_from: "liiteri"
      };

      this.loginService.login(userObject).subscribe((succ) => {
        if (succ) {
          if (succ.status == "failed") {
            this.commonService.getTranslationResponse('errorToastr', 'INVALID_EMAIL_OR_PASSWORD');
            this.spinner.hide();
          }
          else {
            this.commonService.getTranslationResponse('successToastr', 'LOGIN_SUCCESS');
           
            localStorage.setItem("token", "Bearer "+succ.data.token.access_token);
            console.log("SUCCESFULL", succ)
            this.loginService.sendMessage(true);
            this.spinner.hide();
            if(this.queryPram){
              this.navigate.navigateTo('open-lock/'+this.queryPram);
          
            }else{
              this.navigate.navigateTo('dashboard/view-links');
          
            }
            }

        }
       
      })
      // this.store.dispatch(new DefaultState({}));

    }
  }

  retrieveData(key) {
    return this.loginForm.value[key];
  }
  showMessage(state) {
    if (state.success) {
      //let message = this.translate.get(state.successMessage);
      this.commonService.getTranslationResponse('successToastr', 'LOGIN_SUCCESS');
      //this.sucesserrorMsg('successToastr', message);
      localStorage.setItem("token", state.user.token);
      localStorage.setItem("name", state.user.name);
      this.nextStep.dispatchUserAction();
      this.navigate.navigateTo('dashboard/create');
    }
    else if (!state.success && state.success !== null && state.success !== undefined) {

      this.commonService.getTranslationResponse('errorToastr', state.errorMessage);
    }
  }

  getTranslationResponse(status, label, text?) {
    if (status && label) {
      this.translate.get(label).subscribe((message) => {
        text = text ? text : ''
        console.log(text)
        this.sucesserrorMsg(status, `${message} ${text}`);
      })
    }

  }
  sucesserrorMsg(status, message) {
    this.message.messageHandler(status, message);
  }

  navigateTo(route) {
    this.navigate.navigateTo(route);
  }
  login3(f: NgForm) {
 /*    this.commonService.emitAnalyticsEvent('auth', `login`, this.commonService.getLocation().pathname);
    this.requestInProgress = true;
    let { email, password } = f.value;
    let validForm = f.valid;
    if (!this.validateFields(f.value)) {
      this.requestInProgress = false;
      return;
    }
    if (!this.basicHelper.validateEmail(email)) {
      this.translateService.get("EMAIL-DOES-NOT-MATCH").subscribe(success => {
        this.commonService.toastMessage("error", success);
        this.error = {
          code: 1,
          message: success
        };
      });
      this.requestInProgress = false;
      return;
    }
   
    this.authService.loginUser({ email, password }).subscribe((succ) => {
      if (succ) {
        console.log('LOGIN COMPONENT ::', succ);
        this.authService.getUser().subscribe((successGettingUser) => {
          if (successGettingUser) {
            let user = successGettingUser['data']['object'];
            this.authService.currentUserDetail.next(successGettingUser['data']['object']);
            let userLang = user.liiteri_user['language'];
            this.translateService.get('USER-LOGIN').subscribe(success => {
              this.commonService.toastMessage("success", success);
              let lang = userLang || this.commonService.getCurrentLang() || 'en';
              // this.translateService.use(lang);
              let url_to_route = `${lang}`;
              if (this.cartService.checkIfSessionExists()) {
                // this.updatePrice();
              }
              if (this.commonService.getLocalStorage('@Liiteri:route') || this.decoded_uri) {
                let productId = this.commonService.getLocalStorage('@Liiteri:route') || this.decoded_uri;
                let productUrl = `${productId}`;
                let new_url = productUrl.split("?",1 );
                this.router.navigate([`${new_url}`]);
                this.requestInProgress = false;
              } else {
                this.router.navigate([`${lang}/dashboard`]);
                this.requestInProgress = false;
              }
            });
          }
        }, err => {
          if (err.code == 481) {
            this.authService.logout().subscribe((d) => {
              console.log('SUCCESS LOGOUT FROM API');
            })
            this.translateService.get('LOG-OUT').subscribe(success => {
              this.commonService.toastMessage("success", success);
              this.commonService.removeStorage();
              this.authService.logoutUser();
              this.productService.logoutUser();
            });
          }
          this.requestInProgress = false;
        })

      }
    }, error => {
      console.log("ERROR AT LOGIN", error);
      this.requestInProgress = false;
    }) */
  }
  fbLogin() {
    /* this.commonService.emitAnalyticsEvent('auth', `facebook_login`, this.commonService.getLocation().pathname);
    this.authService.logFbUser().then((fbUserSuccess: facebookLogin) => {
      if (fbUserSuccess['error']) {
        this.translateService.get('ERROR-FB').subscribe(success => {
          this.commonService.toastMessage("error", success);
          this.requestInProgress = false;
        });
        console.log('fbUserSuccess ::', fbUserSuccess);
        return;
      } else {
        console.log('fbUserSuccess ::', fbUserSuccess);
        // let { email, id:uid, name } = fbUserSuccess;
        fbUserSuccess.uid = fbUserSuccess.id;
        fbUserSuccess.uid_from = 'facebook';
        fbUserSuccess.account_from = "liiteri";
        fbUserSuccess['first_name'] = fbUserSuccess.name.split(' ')[0];
        fbUserSuccess['last_name'] = fbUserSuccess.name.split(' ')[1];
        this.authService.registerUser(fbUserSuccess).subscribe((succ) => {
          if (succ) {
            console.log('LOGIN COMPONENT ::', succ);
            let responseObj = succ['data'].object;
            let oldSocialUser = responseObj['phone'];
            if (!oldSocialUser) {
              this.authService.social = fbUserSuccess;
              this.authService.social['username'] = responseObj['username'];
              let lang = this.commonService.getCurrentLang() || 'en';
              this.router.navigate([`${lang}/signup`]);
              this.requestInProgress = false;
              return
            }
            this.authService.getUser().subscribe((successGettingUser) => {
              if (successGettingUser) {
                let user = successGettingUser['data']['object'];
               
                let userLang = user.liiteri_user['language'];
                let lang = userLang || this.commonService.getCurrentLang() || 'en';
                if (this.cartService.checkIfSessionExists()) {
                this.updatePrice();
                }
                this.translateService.get('USER-LOGIN').subscribe(success => {
                  let continue_path = this.route.queryParams['_value'].continue ? this.route.queryParams['_value'].continue : '';
                  let verified_user = this.commonService.userIsVerified(user);
                  if (!verified_user) {
                    this.routeTo(`account/steps`);
                  } else {
                    this.router.navigate([`${lang}/${continue_path}`]);
                  }
                  // this.router.navigate([`${lang}`]);
                  this.commonService.toastMessage("success", success);
                  this.requestInProgress = false;
                });
              }
            })
          }
        })
      }
    }) */
  }
}







